import { sanitizeTitle } from '../../js/admin/components/sanitizeTitle';


document.querySelectorAll( '.b-post-content-container' ).forEach( ( block ) => {


	const tableOfContent = block.querySelector( '.b-post-content-container__toc-item' );
	const mediaQuery = window.matchMedia( '(max-width: 896px)' );

	if ( tableOfContent ) {


		document.querySelector( 'main' ).classList.add( 'top-spacing' )
		const nesting = parseInt( tableOfContent.dataset.nest, 10 );
		let contentWrapper = block.querySelector( '.wp-block-post-content' );
		if ( !contentWrapper ) {

			contentWrapper = block.querySelector( '.b-post-content-container__content' );

		}

		if ( contentWrapper ) {

			let headers;
			switch ( nesting ) {

			case 1:
				headers = contentWrapper.querySelectorAll( 'h2' );
				break;
			case 2:
				headers = contentWrapper.querySelectorAll( 'h2, h3' );
				break;
			default:
				break;

			}

			let lastH2ListItem;
			const ol = document.createElement( 'ol' );
			ol.classList.add( 'toc__list' )
			tableOfContent.appendChild( ol );

			for ( let i = 0; i < headers.length; i++ ) {

				const header = headers[ i ];
				const id = header.textContent;

				header.id = sanitizeTitle( id );
				const a = document.createElement( 'a' );
				a.classList.add( 'toc__link' )
				a.href = `#${header.id}`;
				a.textContent = header.textContent;
				const listItem = document.createElement( 'li' );
				listItem.classList.add( 'toc__element' )

				listItem.appendChild( a );

				if ( header.tagName === 'H2' ) {

					lastH2ListItem = listItem;
					ol.appendChild( listItem );

				}

				if ( header.tagName === 'H3' && nesting === 2 ) {

					if ( lastH2ListItem ) {

						let parentList = lastH2ListItem.querySelector( 'ul' );
						if ( !parentList ) {

							parentList = document.createElement( 'ul' );
							parentList.classList.add( 'toc__inner-list' )
							lastH2ListItem.appendChild( parentList );

						}
						parentList.appendChild( listItem );

					}

				}

			}

		}

	}


	const headersWithId = block.querySelector( '.b-post-content-container__content' ).querySelectorAll( 'h2[id], h3[id]' );
	const selectElement = block.querySelector( '.js-toc-select' );


	if ( headersWithId.length > 0 && selectElement ) {

		selectElement.textContent = headersWithId[ 0 ].textContent

	}


	const observerOptions = {
		rootMargin: `-121px 0px ${( window.innerHeight ) * -1}px 0px`,
		threshold: 0
	}
	const observer = new IntersectionObserver( ( elements ) => {

		elements.forEach( el => {

			const headingId = el.target.getAttribute( 'id' );
			const headingText = el.target.textContent;
			const tocHeading = el.target.closest( 'body.single' )?.querySelector( `.b-post-content-container__toc-item a[href="#${headingId}"]` );
			const tocElement = tocHeading?.closest( '.toc__element' );
			const currentTocElement = tocElement?.closest( '.toc__list' )?.querySelector( '.is-active' );

			if ( el.isIntersecting ) {

				currentTocElement?.classList.remove( 'is-active' );
				tocElement?.classList.add( 'is-active' );

				if ( selectElement ) {

					selectElement.textContent = headingText

				}

			} else if ( el.target.getAttribute( 'id' ) === currentTocElement?.querySelector( '.toc__link' )?.getAttribute( 'href' )?.substring( 1 ) ) {

				const prevTocHeading = currentTocElement.previousElementSibling;

				if ( el.boundingClientRect.top > ( window.innerHeight / 2 ) ) {

					currentTocElement?.classList.remove( 'is-active' );
					prevTocHeading?.classList.add( 'is-active' );
					if ( prevTocHeading ) {

						selectElement.textContent = prevTocHeading.textContent

					}

				}

			}

		} );

	}, observerOptions );

	if ( headersWithId.length ) {

		headersWithId.forEach( header => {

			observer.observe( header );

		} );

	}

	const tocLinks = tableOfContent?.querySelectorAll( '.toc__link' );


	tocLinks?.forEach( link => {


		link.addEventListener( 'click', ( event ) => {

			headersWithId.forEach( header => {

				observer.unobserve( header );

			} );

			event.preventDefault();

			block.querySelectorAll( '.toc__element.is-active' ).forEach( ( el ) => {

				el.classList.remove( 'is-active' );

			} );

			event.target.parentElement.classList.add( 'is-active' );
			selectElement.textContent = event.target.textContent

			const id = event.target.hash;
			const header = document.querySelector( id );
			header.scrollIntoView( { behavior: 'smooth' } );
			history.pushState( null, null, id );

			if ( selectElement && mediaQuery.matches ) {

				const dropDownList = tableOfContent.querySelector( '.toc__list' );
				selectElement.classList.remove( 'is-active' );
				dropDownList.classList.remove( 'is-active' );
				dropDownList.style.height = 0;

			}

			setTimeout( () => {

				headersWithId.forEach( headerWithId => {

					observer.observe( headerWithId );

				} );

			}, 800 );

		} );

	} );


	if ( selectElement ) {

		const dropDownList = tableOfContent.querySelector( '.toc__list' );
		const dropDownHeight = `${dropDownList.scrollHeight}px`
		const childrenNav = block.querySelector( '.b-children-posts-navigation' );


		selectElement.addEventListener( 'click', () => {


			if ( !selectElement.classList.contains( 'is-active' ) ) {

				selectElement.classList.add( 'is-active' );

				dropDownList.classList.add( 'is-active' );

				if ( childrenNav && childrenNav.classList.contains( 'mobile' ) ) {

					dropDownList.style.height = `${dropDownList.scrollHeight + childrenNav.scrollHeight}px`

				} else {

					dropDownList.style.height = dropDownHeight;

				}


			} else {

				selectElement.classList.remove( 'is-active' );
				dropDownList.style.height = 0;
				dropDownList.classList.remove( 'is-active' );

			}

		} )

		/**
		 * Function that handles showing/hiding a mobile table of contents dropdown menu.
		 *
		 * @param {MediaQueryList} e - MediaQueryListEvent representing the media query match result
		 */
		const mobileTocDropdown = ( e ) => {

			if ( e.matches ) {

				if ( childrenNav ) {

					childrenNav.classList.add( 'mobile' )
					dropDownList.appendChild( childrenNav )

				}
				dropDownList.style.height = 0;

			} else {

				selectElement.classList.remove( 'is-active' );
				dropDownList.style.height = `${dropDownList.scrollHeight}px`;

			}

		}

		mediaQuery.addEventListener( 'change', mobileTocDropdown );
		mobileTocDropdown( mediaQuery )


	}

} );
